import { Injector, OnInit, ViewChild, AfterViewInit } from '@angular/core';

import DataGrid from 'devextreme/ui/data_grid';
import { DxDataGridComponent } from 'devextreme-angular';
import { GridDataSource } from './dynamic-grid.component';
import { KmmNgBackendService } from 'kmm-ng-backend';

export abstract class DynamicGridPresenterComponent implements OnInit, AfterViewInit {

   @ViewChild('grid', { static: true }) grid: DxDataGridComponent;

   abstract $dataSource: GridDataSource;
   $columns: any = [];

   _toolbar: any;
   _appService: KmmNgBackendService;

   constructor(
      protected _injector: Injector
   ) {
      this._appService = this._injector.get(KmmNgBackendService);
   }

   ngOnInit() {
      DataGrid.defaultOptions({
         device: { deviceType: 'desktop' },
         options: {
            allowColumnResizing: true,
            allowColumnReordering: true,
            columnAutoWidth: true,
            columnChooser: { enabled: true },
            export: {
               allowExportSelectedData: false,
               enabled: true,
               fileName: 'lista',
            },
            filterRow: { visible: true },
            filterSyncEnabled: true,
            groupPanel: { visible: true },
            grouping: { autoExpandAll: true },
            headerFilter: { visible: true },
            onToolbarPreparing: this.onToolbarPreparing,
            pager: {
               allowedPageSizes: [5, 10, 20, 50],
               showInfo: true,
               showPageSizeSelector: true
            },
            scrolling: {
               scrollByContent: true,
               scrollByThumb: true,
               showScrollbar: 'always',
               useNative: false
            },
            selection: { mode: false },
            showRowLines: false,
            stateStoring: { enabled: false, type: 'localStorage', storageKey: this.$dataSource.contextName },
            wordWrapEnabled: true
         }
      });

   }

   ngAfterViewInit() {
      this.$columns = this.grid.columns;

      this.loadDataSource();
   }

   loadDataSource = (reload: boolean = false) => {
      this._appService.backendCall(this.$dataSource.module, this.$dataSource.operation, this.$dataSource.params, null, { gridCols: true })
         .subscribe(result => {
            if (reload) {
               this.grid.instance.option('dataSource', result.data);
            } else {
               const backendCols = result.cols;

               backendCols.forEach(col => {
                  this.$columns.forEach();
               });

               this.grid.columns = result.cols.concat(this.$columns);

               this.grid.instance.option('dataSource', result.data);
            }
         });
   }

   onToolbarPreparing = (event) => {
      const toolbarItems = event.toolbarOptions.items;

      toolbarItems.forEach(function (item) {
         if (item.name === 'searchPanel') {
            item.location = 'after';
         }
      });

      const defaultItems = [
         {
            location: 'after',
            widget: 'dxButton',
            options: {
               icon: 'refresh',
               hint: 'Atualizar',
               elementAttr: {
                  id: 'atualizar'
               },
               onClick: this.refreshGrid
            }
         },
         {
            location: 'after',
            widget: 'dxButton',
            options: {
               icon: 'fas fa-table',
               hint: 'Modelo',
               elementAttr: {
                  id: 'modelo'
               },
               onClick: this.toggleModeloPopup
            }
         }
      ];

      let items;

      if (this._toolbar) {
         items = defaultItems.concat(this._toolbar);
      } else {
         items = defaultItems;
      }

      items.forEach(item => {
         toolbarItems.push(item);
      });
   }

   refreshGrid = () => {
      this.loadDataSource(true);
   }

   toggleModeloPopup = (showForm: boolean = false) => {
      // this.modeloGridLista.visible = true;
      // this.modeloGridLista.modeloGridForm.visible = showForm;
   }

}
